import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ajaxPreUrl } from '@/config';
import axios from 'axios';
import Drip from 'drip';
import DetailNew from '@/pages/detail-new';
import DetailNewV2 from '@/pages/detail-new-v2';
import LimitPage from 'comp/common/limit/LimitPage';
import { HAS_COUNTTIME_LIMIT_CODE, LimitObjectConfig, LIMIT_CODE } from '@/common/index';
export default {
  name: 'detail-new-router',
  data: function data() {
    return {
      showNewMode: undefined,
      isLimitPage: false,
      // 是否页面层面限流
      limitCount: 0,
      showLimitMask: false,
      pageInitErrType: ''
    };
  },
  components: {
    DetailNew: DetailNew,
    DetailNewV2: DetailNewV2,
    LimitPage: LimitPage
  },
  created: function created() {
    var isNewPage = this.$route.query.isNewPage;
    // 如果携带isNewPage标识，使用isNewPage判断展示新老页面
    if (this.checkNewPage(isNewPage)) {
      var _isNewPage$split = isNewPage.split("?"),
        _isNewPage$split2 = _slicedToArray(_isNewPage$split, 1),
        showNewMode = _isNewPage$split2[0];
      this.showNewMode = JSON.parse(showNewMode);
    } else {
      // 如果未携带isNewPage标识，请求接口获取新老项目标识
      this.getDetailPageMode();
    }
  },
  beforeCreate: function beforeCreate() {},
  methods: {
    getDetailPageMode: function getDetailPageMode() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var uuid, res, _ref, data, code, msg, _ref$isErrCatched, isErrCatched, _window$Owl, msgstr;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return Drip.getUuid();
            case 2:
              uuid = _context.sent;
              _context.next = 5;
              return axios({
                url: "".concat(ajaxPreUrl, "/mode/project/").concat(_this.performanceIdByRoute),
                method: 'get',
                headers: {
                  'Content-type': 'application/json',
                  'uuid': uuid
                }
              }).catch(function (err) {
                _this.setPageLimitObject(undefined, data);

                // 拼接细分异常
                var msg = err !== null && err !== void 0 && err.message ? "-".concat(err.message) : '';
                window.Owl && window.Owl.addError({
                  name: "\u65B0\u9879\u76EE\u8BE6\u60C5\u9875-\u67E5\u8BE2\u65B0\u8001\u9879\u76EE\u63A5\u53E3\u5F02\u5E38".concat(msg),
                  msg: {
                    projectId: _this.performanceIdByRoute,
                    error: {
                      message: err.message,
                      stack: err.stack
                    }
                  }
                });
                return {
                  /**
                   * 是否上报过该异常
                   */
                  isErrCatched: true
                };
              });
            case 5:
              res = _context.sent;
              _ref = res || {}, data = _ref.data, code = _ref.code, msg = _ref.msg, _ref$isErrCatched = _ref.isErrCatched, isErrCatched = _ref$isErrCatched === void 0 ? false : _ref$isErrCatched;
              if (LIMIT_CODE.includes(code)) {
                _this.setPageLimitObject(code, data);
              } else if (code === 200) {
                _this.closeLimitPage();
                _this.showNewMode = Boolean(Number(data.isNewMode));
              } else {
                _this.setPageLimitObject(code, data);

                // 是否上报过异常检测
                if (!isErrCatched) {
                  // 拼接细分异常
                  msgstr = msg ? "-".concat(msg) : ''; // 异常上报
                  window.Owl && ((_window$Owl = window.Owl) === null || _window$Owl === void 0 ? void 0 : _window$Owl.addError({
                    name: "\u65B0\u9879\u76EE\u8BE6\u60C5\u9875-\u67E5\u8BE2\u65B0\u8001\u9879\u76EE\u63A5\u53E3\u5F02\u5E38".concat(msgstr),
                    msg: {
                      projectId: _this.performanceIdByRoute,
                      error: {
                        code: code,
                        message: msg || '接口异常'
                      }
                    }
                  }));
                }
              }
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    checkNewPage: function checkNewPage(isNewPage) {
      return isNewPage !== undefined && (isNewPage === "true" || isNewPage === "false");
    },
    closeLimitPage: function closeLimitPage() {
      var _this2 = this;
      this.showLimitMask = true;
      this.closeLimitPageTimer = null;
      this.closeLimitPageTimer = setTimeout(function () {
        _this2.isLimitPage = false;
        _this2.showLimitMask = false;
      }, 300);
    },
    setPageLimitObject: function setPageLimitObject(code) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      try {
        this.limitCount = this.limitCount + 1;
        this.limitObject = {
          hasCountTime: code === HAS_COUNTTIME_LIMIT_CODE,
          backgroundImage: data.url || LimitObjectConfig.defaultLimitModalImage,
          defaultLimitTime: code === HAS_COUNTTIME_LIMIT_CODE ? data.interval || LimitObjectConfig.interval : 0,
          buttonText: data.buttonText,
          text: LIMIT_CODE.includes(code) ? data.text || LimitObjectConfig.limitContent : LimitObjectConfig.errorContent
        };
        if (this.closeLimitPageTimer) {
          clearTimeout(this.closeLimitPageTimer);
          this.closeLimitPageTimer = null;
        }
        this.isLimitPage = true;
        this.showLimitMask = false;
      } catch (e) {}
    }
  },
  computed: {
    performanceIdByRoute: function performanceIdByRoute() {
      var performanceId = +this.$route.params.performanceId;
      if (isNaN(performanceId)) {
        performanceId = +this.$route.params.performanceId.match(/\d+/)[0];
      }
      return performanceId;
    }
  },
  // TODO 当改会/detail/  路径的时候要把detail-new 改回 detail
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    next();
    // 非native页面使用router.push情况跳转时候强制刷新页面
    if (/detail\/[0-9]\d*/.test(to.path) && !Drip.UA.isNative) {
      window.location.reload();
    }
  }
};